import {
    HttpEvent,
    HttpHandlerFn,
    HttpInterceptorFn,
    HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { bodyToSanitizedBody } from '../../models/body/body.mapper';

export const EmptyValueInterceptor: HttpInterceptorFn = (
    request: HttpRequest<unknown>,
    next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
    if (['POST', 'PUT'].includes(request.method)) {
        request = request.clone({
            body: bodyToSanitizedBody(request.body),
        });
    }

    return next(request);
};
